import { index, jsonb, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getTimestampWithTimezone,
} from '../common/utils'

export type ProductImportCounts = {
  inserted: number
  updated: number
  deleted: number
  byChangeType: Record<string, number>
}

export const productImportRuns = pgTable(
  'product_import_runs',
  {
    ...getBaseFields(),
    supplier: text().notNull(),
    status: text().notNull(),
    catalogPublishedAt: getTimestampWithTimezone(),
    startedAt: getTimestampWithTimezone().notNull().defaultNow(),
    finishedAt: getTimestampWithTimezone(),
    counts: jsonb().$type<ProductImportCounts>(),
    reportStorageKey: text(),
    error: text(),
  },
  (table) => [
    ...getBaseIndexes('product_import_runs', table),
    index('product_import_runs_started_at_idx').on(table.startedAt),
  ],
)
